export const isValidNumber = value => {
  return /^\d+$/.test(value)
}
